import styled from "styled-components";
import React from "react";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";

type ProgressBarProps = {
  /** Fraction complete, 0 to 1. */
  value: number;
  color?: string;
  /** Accessible name, e.g. "Goal progress". Screen readers then read the percentage. */
  label?: string;
} & LayoutProps &
  SpaceProps;

const Container = styled.div`
  ${layout};
  height: 6px;
  background-color: ${(props) => props.theme.colors.grey4};
  border-radius: 2px;
  overflow: hidden;
  ${space};
`;

const Bar = styled.div<{ value: number; color: string }>`
  width: ${(props) => props.value * 100}%;
  height: 100%;
  background-color: ${(props) => props.theme.colors[props.color]};
  transition: width 0.3s ease;
`;

export const ProgressBar = ({
  value,
  color,
  label,
  ...rest
}: ProgressBarProps) => {
  const clamped = Math.max(0, Math.min(1, value));

  return (
    <Container
      {...rest}
      role="progressbar"
      aria-label={label}
      aria-valuenow={Math.round(clamped * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <Bar value={clamped} color={color ?? "primary"} />
    </Container>
  );
};
